/*
 *
 * TutorialTour actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const displayTutorialAction = (isOpen: boolean) =>
  action(ActionTypes.DISPLAY_TUTORIAL, { isOpen });

export const goToStepTutorialAction = (stepNumber: number) =>
  action(ActionTypes.GO_TO_STEP_TUTORIAL, { stepNumber });
